module.exports = __webpack_public_path__ + "static/media/trainposter.795f7ceb.jpeg";